import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AppEnvironment, environment } from "src/environments/environment";

export type FeatureFlag = keyof Pick<
  AppEnvironment,
  | "enableDisbursement"
  | "enableOverloadMemo"
  | "enableCompensationSummary"
  | "enableErpLeaveImport"
>;

// Release 1.1 — release-2 areas are frontend-hidden; direct URLs land on 404
// as if the feature does not exist in this release.
export function featureEnabledGuard(flag: FeatureFlag): CanActivateFn {
  return () => environment[flag] || inject(Router).createUrlTree(["/error/404"]);
}
